import { render, staticRenderFns } from "./TeamsEditor.vue?vue&type=template&id=0da28da9&scoped=true"
import script from "./TeamsEditor.vue?vue&type=script&lang=js"
export * from "./TeamsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da28da9",
  null
  
)

export default component.exports